/**
 * Gradient type definitions shared between potree_fork and client
 *
 * These types define the available color gradients for point cloud visualization.
 * The actual gradient values with THREE.Color instances are defined in potree_fork,
 * but these type definitions are shared to ensure consistency.
 */

/** A single stop in a gradient: [position (0-1), color] */
export type GradientStop = [number, { r: number; g: number; b: number }];

/** Array of gradient stops defining a complete gradient */
export type GradientDefinition = GradientStop[];

/** Interface defining all available gradient presets */
export interface GradientsType {
  SPECTRAL: GradientDefinition;
  PLASMA: GradientDefinition;
  YELLOW_GREEN: GradientDefinition;
  VIRIDIS: GradientDefinition;
  INFERNO: GradientDefinition;
  GRAYSCALE: GradientDefinition;
  TURBO: GradientDefinition;
  RAINBOW: GradientDefinition;
  CONTOUR: GradientDefinition;
  PURE_PURPLE: GradientDefinition;
}

/** Union type of all gradient preset names */
export type GradientType = keyof GradientsType;

/** Every gradient preset name, for runtime validation of stored settings. */
export const GRADIENT_TYPES = ['SPECTRAL', 'PLASMA', 'YELLOW_GREEN', 'VIRIDIS', 'INFERNO', 'GRAYSCALE', 'TURBO', 'RAINBOW', 'CONTOUR', 'PURE_PURPLE'] as const satisfies readonly GradientType[];
